import {Component, Input} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../../../services/enumeration.service';

@Component({
  selector: 'app-commentary-entry',
  templateUrl: './commentary-entry.component.html',
  styles: []
})
export class CommentaryEntryComponent extends ExcTranslation {
  entry: any;
  expand = false;

  @Input()
  set dataToShow(entry: any) {
    this.entry = entry;
  }

  constructor(public enmService: EnumerationService) {
    super();
  }

  getDateCompare(date: any): string {
    const dt = new Date(date);
    return dt.getFullYear() + '' + (dt.getMonth() + 1) + '' + dt.getDate();
  }

  isOverflow = () => {
    return false;
  }
}
